import store from "@/state/store";

export default [
    {
        path: "/",
        name: "default",
        meta: {
            authRequired: true,
        },
        component: () => import("./pages/dashboards/default"),
    },
    // {
    //     path: "/login/:token",
    //     name: "login",
    //     component: () => import("./pages/account/login"),
    // },
    {
        path: "/login/:token",
        name: "login",
        component: () => import("./views/login/login.vue"),
    },
    {
        path: "/login",
        name: "notken-login",
        component: () => import("./pages/account/login"),
    },
    {
        path: "/register",
        name: "Register",
        component: () => import("./pages/account/register"),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                // If the user is already logged in
                if (store.getters["auth/loggedIn"]) {
                    // Redirect to the home page instead
                    next({ name: "default" });
                } else {
                    // Continue to the login page
                    next();
                }
            },
        },
    },
    {
        path: "/forgot-password",
        name: "Forgot password",
        component: () => import("./pages/account/forgot-password"),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                // If the user is already logged in
                if (store.getters["auth/loggedIn"]) {
                    // Redirect to the home page instead
                    next({ name: "default" });
                } else {
                    // Continue to the login page
                    next();
                }
            },
        },
    },
    {
        path: "/logout",
        name: "logout",
        meta: {
            authRequired: true,
            beforeResolve(routeTo, routeFrom, next) {
                if (process.env.VUE_APP_DEFAULT_AUTH === "firebase") {
                    store.dispatch("auth/logOut");
                } else {
                    store.dispatch("authfack/logout");
                }
                const authRequiredOnPreviousRoute = routeFrom.matched.some((route) => route.push("/login"));
                // Navigate back to previous page, or home as a fallback
                next(authRequiredOnPreviousRoute ? { name: "default" } : { ...routeFrom });
            },
        },
    },
    {
        path: "/404",
        name: "404",
        component: require("./pages/utility/404").default,
    },
    // Redirect any unmatched routes to the 404 page. This may
    // require some server configuration to work in production:
    // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
    {
        path: "*",
        redirect: "404",
    },

    // ! certman routing
    {
        path: "/suppliers/:client_id",
        name: "suppliers",
        meta: { authRequired: true },
        component: () => import("./views/suppliers/suppliers.vue"),
    },
    {
        path: "/collectionslist",
        name: "collectionslist",
        meta: { authRequired: true },
        component: () => import("./views/collections/collectionslist.vue"),
    },
    {
        path: "/clients",
        name: "clients",
        meta: { authRequired: true },
        component: () => import("./views/clients/clients.vue"),
    },
    {
        // path: "/collectionslist-client-suppliers",
        path: "/collectionslist/client",
        name: "",
        meta: { authRequired: true },
        component: () => import("./views/collections/collectionslist-client-suppliers.vue"),
    },
    {
        // path: "/collectionslist-client-suppliers",
        path: "/collectionslist/client/:client_id",
        name: "",
        meta: { authRequired: true },
        component: () => import("./views/collections/collectionslist-client-suppliers.vue"),
    },
    {
        // path: "/collectionslist-client-suppliers",
        path: "/certificate-authentication",
        name: "",
        meta: { authRequired: true },
        component: () => import("./views/certificate-authentication/certificate-authentication.vue"),
    },
    {
        // path: "/collectionslist-client-suppliers",
        path: "/authentication-history",
        name: "",
        meta: { authRequired: true },
        component: () => import("./views/certificate-authentication/authentication-history.vue"),
    },
    {
        // path: "/collectionslist-client-suppliers",
        path: "/validation-and-checks",
        name: "",
        meta: { authRequired: true },
        component: () => import("./views/validation-checks/validation-checks.vue"),
    },
    {
        // path: "/collectionslist-client-suppliers",
        path: "/user-administration",
        name: "",
        meta: { authRequired: true },
        component: () => import("./views/user-administration/userAdministration.vue"),
    },
    {
        // path: "/collectionslist-client-suppliers",
        path: "/user-administration/:user_id",
        name: "",
        meta: { authRequired: true },
        component: () => import("./views/user-administration/userPermissions.vue"),
    },
];
